import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const Faqs = () => (
  <StyledSection>
    <Title>Frequently asked questions</Title>
    <FaqsWrapper>
      <Faq>
        <FaqTitle>What features are included in each plan?</FaqTitle>
        <FaqContent>
          All Commerce7 plans include all features and functionality. We do not
          segment our feature set by plan, all Commerce7 clients have access to
          every tool on our platform.
        </FaqContent>
      </Faq>
      <Faq>
        <FaqTitle>How much does it cost to migrate to Commerce7?</FaqTitle>
        <FaqContent>
          Commerce7 doesn’t charge you to migrate. Migration costs depend on the
          volume of data you have and your existing platform. Migration is
          handled by professional third-party partners, and a Commerce7 sales
          associate can outline potential costs and resources needed.
        </FaqContent>
      </Faq>
      <Faq>
        <FaqTitle>What are your credit card fees for payment?</FaqTitle>
        <FaqContent>
          Credit card fees vary depending on your country, transaction volume,
          transaction history. Generally, our integrated partners are
          competitive and will match or beat your existing rates.
        </FaqContent>
      </Faq>
      <Faq>
        <FaqTitle>How does the transaction fee work?</FaqTitle>
        <FaqContent>
          The transaction fee charged by Commerce7 is based on gross sales which
          includes shipping, taxes, and product costs. The only revenue excluded
          when calculating our transaction fee is employee tips.
        </FaqContent>
      </Faq>
      <Faq>
        <FaqTitle>What other fees are there?</FaqTitle>
        <FaqContent>
          None - but there are other optional costs associated with using 3rd
          party apps and integrations.
        </FaqContent>
      </Faq>
    </FaqsWrapper>
  </StyledSection>
);

const StyledSection = styled(Section)`
  margin-bottom: 125px;
`;

const Title = styled.h2`
  font-weight: var(--font-weight-bold);
  color: var(--blue-dark);
  font-size: var(--heading-size-base);
  margin-bottom: 95px;
`;

const FaqsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;

const Faq = styled.li`
  width: 100%;
  margin-bottom: 60px;

  ${({ theme }) => `
    @media ${theme.mediumUp} {
        padding-right: 50px;
        width: 50%;
    }
    @media ${theme.largeUp} {
        width: 33%;
    }
`}
`;

const FaqTitle = styled.h5`
  font-weight: var(--font-weight-bold);
  margin-bottom: 5px;
`;

const FaqContent = styled.p``;

export default Faqs;
